// Flat, searchable list of admin pages for the header quick-search box.
// Mirrors the nav tree in routes/dashboard/Sd.js — keep the two in sync when
// adding/removing/renaming a page there.
const NAV_SEARCH_ITEMS = [
  { label: 'Dashboard', group: 'Management', route: '/dashboard' },

  { label: 'Add New Employee', group: 'Employees', route: '/createemployee' },
  { label: 'Onboarding', group: 'Employees', route: '/onboarding' },
  { label: 'Documents', group: 'Employees', route: '/uploademployee/docs' },
  { label: 'Bulk Action', group: 'Employees', route: '/uploaddata' },
  { label: 'Total Employee', group: 'Employees', route: '/employees' },
  { label: 'Inactive', group: 'Employees', route: '/resigned/employees' },

  { label: 'Income Tax Calculator', group: 'Calculator', route: '/tax-calculator' },

  { label: 'Salary View', group: 'Payroll', route: '/payroll' },
  { label: 'Processing', group: 'Payroll', route: '/payroll/process' },
  { label: 'Bulk Updates', group: 'Payroll', route: '/payroll/bulk-salary' },
  { label: 'Pay Slip Logs', group: 'Payroll', route: '/payroll/logs' },
  { label: 'Detailed Salary Report', group: 'Payroll', route: '/payroll/detailed-salary-report' },

  { label: 'Form 16 Certificates', group: 'Form 16', route: '/payroll/form16' },
  { label: 'Tax Declarations', group: 'Form 16', route: '/payroll/form16/declarations' },
  { label: 'Rectifications', group: 'Form 16', route: '/payroll/form16/rectifications' },
  { label: 'Employer / FY Setup', group: 'Form 16', route: '/payroll/form16/employer' },

  { label: 'Total Applies', group: 'Interview', route: '/totalcandidates' },
  { label: 'Job Openings', group: 'Recruitment', route: '/job-openings' },
  { label: 'Job Applications', group: 'Recruitment', route: '/job-applications' },
  { label: 'Scheduled', group: 'Interview', route: '/scheduledcandidates' },
  { label: 'Selected', group: 'Interview', route: '/selectedcandidates' },
  { label: 'Rejected', group: 'Interview', route: '/rejectedcandidates' },
  { label: 'On Process', group: 'Interview', route: '/progresscandidates' },

  { label: 'Projects', group: 'People', route: '/projects' },
  { label: 'Contacts', group: 'People', route: '/contacts' },
  { label: 'Leave Requests', group: 'Attendance', route: '/leaves' },
  { label: 'Daily Status', group: 'Attendance', route: '/attendance/present' },
  { label: 'Team Analysis', group: 'Attendance', route: '/team-leaves' },
  { label: 'Tracker', group: 'Attendance', route: '/leave-tracker' },

  { label: 'My Profile', group: 'Preferences', route: '/settings' },
  { label: 'Company Settings', group: 'Preferences', route: '/settings/company-profile' },
  { label: 'Master Records', group: 'Preferences', route: '/master-data' },
  { label: 'User Role Management', group: 'Preferences', route: '/settings/roles' },
  { label: 'Activity Logs', group: 'Preferences', route: '/settings/activity-logs' },
];

export default NAV_SEARCH_ITEMS;
